import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../messages/en.json';
import es from '../messages/es.json';

const LOCALE_STORAGE_KEY = 'tenant-ui-locale';

function getSavedLocale(): string {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored === 'en' || stored === 'es') return stored;
  } catch {
    // test env
  }
  return 'en';
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es } },
  lng: getSavedLocale(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function changeLanguage(locale: string) {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  i18n.changeLanguage(locale);
}

export default i18n;
